module.exports = __webpack_public_path__ + "img/gs.cffdb3b8.png";